import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

const Contact = () => {
    return (
        <section className="py-20 bg-gradient-to-r from-purple-900/30 to-slate-800">
            <div className="container flex flex-col justify-center items-center mx-auto px-4 text-center">
                <h2 className="text-4xl font-bold mb-6">¿Listo para Conectarte?</h2>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                    Solicitá tu instalación hoy mismo y comenzá a disfrutar de nuestros servicios
                </p>
                <a
                    to="https://wa.me/5493571458075"
                    target="_blank"
                    className="bg-purple-900 text-base md:text-lg h-12 border-white border hover:bg-purple-800 w-fit  text-center text-white px-6 py-3 rounded-full flex items-center gap-2 transition"
                >
                    <FaWhatsapp />
                    Contáctanos
                </a>
            </div>
        </section>
    )
}
export default Contact